import type { StageAction } from "@components/campaigns/StageActionBar";
import { useOutletContext } from "react-router";

export interface CampaignDetailContext {
  campaign: Campaign;
  refresh: () => void;
}

export interface WorkflowArtefactStatus {
  kind: string;
  label: string;
  status: "complete" | "pending" | "ready" | "blocked" | "generating";
  blockedReason?: string | null;
  locked: boolean;
  hasLockGate: boolean;
  dependencies: string[];
  phase: string;
}

export interface Campaign {
  id: string;
  title: string;
  status: string;
  archivedAt?: string | null;
  archiveReason?: string | null;
  currentStage: number;
  candidateCount: number;
  scoredCandidateCount: number;
  createdAt: string;
  client: { id: string; name: string; industry?: string | null };
  createdBy: { id: string; name: string };
  teamMembers?: { id: string; name: string }[];
  attachedNotes?: unknown[];
  artefacts?: unknown[];
  campaignSuggestions?: unknown[];
  stageActions?: StageAction[];
  roleBlueprint?: unknown;
  brief?: {
    id: string;
    currentVersion?: {
      id: string;
      targetStartDate?: string | null;
    } | null;
  } | null;
  activityEvents?: CampaignActivityEvent[];
  decisionSummary?: CampaignDecisionSummary | null;
  workflowStatus?: WorkflowArtefactStatus[];
}

export interface CampaignDecisionSummary {
  id: string;
  strengthSignal: "high" | "mixed" | "low" | "unknown";
  keyGap: string;
  recommendedAction: string;
  model: string | null;
  generatedAt: string;
  stale: boolean;
}

export type CampaignActivityEventKind = "stage_change" | "brief_version" | "job_posting_version";

export interface CampaignActivityEvent {
  id: string;
  kind: CampaignActivityEventKind;
  occurredAt: string;
  summary: string;
  details: Record<string, unknown>;
  actor: { id: string; name: string } | null;
}

export function useCampaignDetail(): CampaignDetailContext {
  return useOutletContext<CampaignDetailContext>();
}

export const STAGE_NAMES = [
  "Brief",
  "Role Blueprint",
  "Market Map / Search",
  "Longlist Creation",
  "Candidate Outreach",
  "Recruiter Assessment",
  "Shortlist Creation",
  "Client Interviews",
  "Offer & Closing",
  "Post-Placement",
];
